// extracted by mini-css-extract-plugin
module.exports = {"container":"InEvidenceCarousel_container__mqkjj","jackpot":"InEvidenceCarousel_jackpot__liFtq","navigationContainer":"InEvidenceCarousel_navigationContainer__1cxWk"};